<template>
  <div class="pageContainer">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.pageContainer {
  margin: 16px 0;
}
</style>
